import React from 'react'

export default function Accordion(props) {
    const {
        id,
        notify_parent,
        currentlyOpen,
        detailsClass,
        summaryClass,
        header,
        headerClass,
        content,
        contentClass,
        includeHr
    } = props

    function toggle_summary(event) {
        event.preventDefault()
        notify_parent(id)
    }


    return (
        <>
            <details className={detailsClass} id={id} open={currentlyOpen} suppressHydrationWarning={true}>
                <summary onClick={toggle_summary} className={summaryClass} suppressHydrationWarning={true}>
                    <h4 className={headerClass} dangerouslySetInnerHTML={{__html: header}}/>
                </summary>
                <div className={contentClass} dangerouslySetInnerHTML={{__html: content}}/>
            </details>
            {includeHr === true ? (<hr className="margin-0x"/>) : `` }
        </>
    )
}
